function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#000",
  cx: 57,
  cy: 57,
  r: 57
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.923 75.812l-6.394-6.396 12.788-12.788L25.529 43.84l6.394-6.395 19.183 19.183-19.183 19.184zm54.641-1.164H57.5v-8.574h29.064v8.574z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

var SvgCli = function SvgCli(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTE0cHgiIGhlaWdodD0iMTE0cHgiIHZpZXdCb3g9IjAgMCAxMTQgMTE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPmNsaTwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iRmxvdy1DTEkiPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJCbGFjayIgZmlsbD0iIzAwMDAwMCIgY3g9IjU3IiBjeT0iNTciIHI9IjU3Ij48L2NpcmNsZT4KICAgICAgICAgICAgPGcgaWQ9Im5vdW5fQ29tbWFuZC1MaW5lXzM5MTA4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNS4wMDAwMDAsIDM3LjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNi45MjMsMzguODEyIEwwLjUyOSwzMi40MTYgTDEzLjMxNywxOS42MjggTDAuNTI5LDYuODQgTDYuOTIzLDAuNDQ1IEwyNi4xMDYsMTkuNjI4IEw2LjkyMywzOC44MTIgWiBNNjEuNTY0LDM3LjY0OCBMMzIuNSwzNy42NDggTDMyLjUsMjkuMDc0IEw2MS41NjQsMjkuMDc0IEw2MS41NjQsMzcuNjQ4IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgCli as ReactComponent };